export const PRODUCT_IMAGE_HOST =
  "https://stwebshopbilder01prod001.blob.core.windows.net";
export const CENTRAL_SERVISA_ID = "199";
